//#region src/api/internal/route.ts
function getMountRoute(opts) {
	const mountRoute = opts.mountRoute ?? `/api/${opts.name}`;
	if (mountRoute.endsWith("/")) return mountRoute.slice(0, -1);
	return mountRoute;
}

//#endregion
export { getMountRoute };
//# sourceMappingURL=route.js.map